<template>
  <div>
    <FilterOrganization :disable="true" @option="onOptionChange" :option="option"/>
    <ManagementAccountHistory class="mb-4" caption="Accounts" icon="cil-user" :item="accounts"  :option="option" :small="true" @select="onCreateAdmin"/>
    <ManagementAccountHistory  caption="Admin" icon="cil-user" :fields="fields" :item="admin"  :option="option"/>

    <DCreateAdmin :isDialog="isDialog" :object="object" @dismiss="onDismiss" @save="onAddInfo"/>
  </div>
</template>

<script>
import moment from "moment/moment";
import {mapGetters} from "vuex";
import ManagementAccountHistory from "@/projects/views/E-Performances/Management/Admin/components/Historys";
import FilterOrganization from "@/projects/components/Filter/FilterOrganization";
import DCreateAdmin from "@/projects/views/E-Performances/Management/Admin/components/DCreateAdmin";

export default {
  name: "Admins",
  components: {DCreateAdmin, FilterOrganization, ManagementAccountHistory},
  data: function () {
    return {
      accounts:[],
      admin:[],
      fields:[
        {key: "index", label: "ลำดับ",  _style: 'width:50px; text-align: center'},
        {key:"code", label:"รหัสบุคลากร", _style: 'width:100px; text-align: center'},
        {key:"agency", label:"agency"},

        {key:"info", label:"ชื่อ-สกุล", _style: 'width:400px;'},
      ],
      option:{
        organization: "66cbe802a41ed9362a8579fa",
        agency: 0,
        year: new Date().getFullYear() + 543,
      },

      isDialog : false,
      object : {}
    }
  },

  mounted() {
  },

  created() {
    this.onInit();
  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      this.onLoad()
    },

    onLoad() {
      var data = {};
      data.organization = this.option.organization;
      (this.option.agency != 0)?data.agency = this.option.agency:null;

      this.$store.dispatch("member/config", data)
      this.$store.dispatch("admin/config")
    },

    onOptionChange(e){
      this.isShow = false;
      this.option = e;
      // this.onLoad();
    },

    onCreateAdmin(item){
      this.isDialog = true;
      this.object = item;
    },

    onDismiss(item){
      this.isDialog = false;
      this.object = {};

    },

    onAddInfo(item){
      this.isDialog = false;

      var data = {};
      data.account = item.value.accounts._id
      data.agency = item.value.agency._id
      this.$store.dispatch("admin/create", data)

      this.onInit();


    }
  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
      objsMember : "member/members",
      objAdmin : "admin/item"
    })
  },

  watch: {
    objsMember: function (value) {
      this.accounts = [];
      var lang = this.$store.getters['setting/lang']
      var items = [];
      value.filter(item => {
        var objs = {};
        try {
          objs.code = item.accounts.code
        }catch (e) {

        }
        objs.info = item.accounts.userinfo.prefix.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value +" "+item.accounts.userinfo.firstName.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value+" "+ item.accounts.userinfo.lastName.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value;
        try {
          objs.agencies = item.agencies.title.filter(title => {
            if (title.key == lang) {
              return title
            }
          })[0].value
        }catch (e) {
          objs.agencies = '-'
        }

        try {
          objs.agency = item.agency.title.filter(title => {
            if (title.key == lang) {
              return title
            }
          })[0].value
        }catch (e) {
          objs.agency = '-'
        }

        // objs.position = item.position.title.filter(title => {
        //   if (title.key == lang) {
        //     return title
        //   }
        // })[0].value
        objs.value = item;
        objs.historys = []

        items.push(objs)
      })
      this.accounts = items;

    },

    objAdmin(value){
      this.admin = [];
      var lang = this.$store.getters['setting/lang']
      var items = [];
      value.filter(item => {
        var objs = {};
        try {
          objs.code = item.account.code
        }catch (e) {

        }
        objs.info = item.account.userinfo.prefix.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value +" "+item.account.userinfo.firstName.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value+" "+ item.account.userinfo.lastName.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value;
        // try {
        //   objs.agencies = item.agencies.title.filter(title => {
        //     if (title.key == lang) {
        //       return title
        //     }
        //   })[0].value
        // }catch (e) {
        //   objs.agencies = '-'
        // }
        //
        try {
          objs.agency = item.agency.title.filter(title => {
            if (title.key == lang) {
              return title
            }
          })[0].value
        }catch (e) {
          objs.agency = '-'
        }
        //
        // // objs.position = item.position.title.filter(title => {
        // //   if (title.key == lang) {
        // //     return title
        // //   }
        // // })[0].value
        objs.value = item;
        // objs.historys = []
        items.push(objs)
      })
      this.admin = items;
    },

    "option.organization"(value){
      this.onLoad()
    },

    "option.agency"(value){
      this.onLoad()
    },

  }
}
</script>

<style scoped>

</style>
